import { PlatePluginOptions } from '@udecode/plate-core';

export const MARK_ITALIC = 'italic';

export const DEFAULTS_ITALIC: Partial<PlatePluginOptions> = {
  hotkey: 'mod+i',
};
